import { requester } from '@space-shell/config/request'

import { NotificationsEndpoints } from './constants'
import type {
  NotificationCount,
  NotificationList,
  NotificationsParams,
  CountParams,
  ReadAllParams
} from './types'

class NotificationsService {
  static getNotifications = async (params: NotificationsParams) => {
    const response = await requester.get<NotificationList>(NotificationsEndpoints.notifications(), {
      params
    })

    return response.data
  }

  static getCount = async (params: CountParams) => {
    const response = await requester.get<NotificationCount>(NotificationsEndpoints.count(), {
      params
    })

    return response.data
  }

  static patchReadAll = async ({ context, markRead }: ReadAllParams) => {
    const response = await requester.patch(NotificationsEndpoints.readAll(), undefined, {
      params: {
        context,
        markRead
      }
    })

    return response.data
  }
}

export default NotificationsService
